import React, { useRef, useEffect } from 'react';

import { useLayoutContext } from '@ott/layout-context';

import { S3_IMAGES_URL } from '../../../../constants';

import { motion, useInView, useAnimation } from 'framer-motion';

type Props = { className?: string };

const OrbitSeven = ({ className }: Props) => {
  const ref = useRef(null);
  const inViewport = useInView(ref);
  const control = useAnimation();
  const { isDesktop } = useLayoutContext();

  const variants = {
    initial: isDesktop
      ? { opacity: 0, scale: 0 }
      : { opacity: 0, scale: 0, left: '50%', right: '50%', x: '-50%', y: '-7%' },
    animate: isDesktop
      ? {
          opacity: 0.7,
          scale: 1,
          transition: { duration: 2 },
        }
      : {
          opacity: 0.7,
          scale: 0.7,
          rotate: 15,
          transition: { duration: 2 },
        },
  };

  useEffect(() => {
    if (inViewport) {
      control.start('animate');
    }
  }, [control, inViewport, isDesktop]);

  return (
    <motion.svg
      ref={ref}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="1837"
      height="796"
      fill="none"
      variants={variants}
      initial="initial"
      animate={control}
    >
      <path
        id="orbitSeven"
        stroke="url(#a)"
        strokeWidth="2"
        shapeRendering="geometricPrecision"
        d="M1831.95 642.766c-11.52 43.009-47.97 77.236-104.18 102.26-56.2 25.022-132.09 40.806-222.34 46.968-180.48 12.323-418.28-13.851-670.6-81.46-252.319-67.609-471.344-163.84-621.488-264.754-75.074-50.459-132.903-102.073-169.066-151.845C8.109 244.159-6.342 196.294 5.182 153.284c11.525-43.009 47.972-77.235 104.181-102.26 56.205-25.022 132.093-40.806 222.338-46.968C512.187-8.267 749.984 17.907 1002.3 85.516c252.32 67.609 471.35 163.84 621.49 264.754 75.08 50.459 132.9 102.073 169.07 151.845 36.16 49.776 50.62 97.641 39.09 140.651Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="1663"
          x2="326.421"
          y1="45.176"
          y2="702.387"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EED7F1" />
          <stop offset=".085" stopColor="#FEFCFE" />
          <stop offset=".192" stopColor="#DBC1D4" />
          <stop offset=".285" stopColor="#6DD2E5" />
          <stop offset=".4" stopColor="#7BA0EB" />
          <stop offset=".51" stopColor="#BC86F6" />
          <stop offset=".632" stopColor="#DCC4F8" />
          <stop offset=".747" stopColor="#BFB5C6" />
          <stop offset=".87" stopColor="#F5F4F6" />
          <stop offset="1" stopColor="#D7CACE" />
        </linearGradient>
      </defs>
      <image
        href={`${S3_IMAGES_URL}planets_for_orbits/planet-7@2x.png`}
        width="50"
        height="50"
        x="1300"
        y="165"
      >
        <mpath href="#orbitSeven" />
      </image>
    </motion.svg>
  );
};

export default OrbitSeven;
